<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />

    <v-container>
      <encabezado :elementos="encabezado" :disabledButton="disabledHeader" />
      <v-card>
        <v-card-text :class="[list.length < 6 ? 'calendar' : '']">
          <!-- <v-container> -->
          <v-data-table
            dense
            :headers="headers"
            :search="search"
            :items="list"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
              'page-text': '{1} de {2}',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            :items-per-page="10"
            fixed-header
            height="auto"
          >
            <template v-slot:top>
              <div class="row">
                <branch-offices-list
                  :classOfDiv="cols"
                  v-on:triggerChange="branchOfficeSelected"
                  :model="idBranchOfficeSelected"
                />
                <div class="col-sm-12 col-md-4 col-xl-3">
                  <div id="handCalendar">
                    <vc-date-picker color="green" v-model="date" is-range :max-date="new Date()">
                      <template v-slot="{ inputEvents }">
                        <div class="flex justify-center items-center">
                          <v-text-field
                            v-on="inputEvents.start"
                            :value="dateCompuded"
                            label="Fecha de interpretación..."
                            :append-icon="
                              validData ? 'mdi-eraser' : 'mdi-calendar'
                            "
                            @click:append="clearCalendar"
                            :disabled-input="validData"
                          ></v-text-field>
                        </div>
                      </template>
                    </vc-date-picker>
                  </div>
                </div>
                <div class="col">
                  <v-text-field
                    v-model.trim="search"
                    label="Buscar"
                    :append-icon="search ? 'mdi-eraser' : 'mdi-magnify'"
                    @click:append="search = ''"
                  ></v-text-field>
                </div>
              </div>
            </template>
          </v-data-table>
          <!-- </v-container> -->
        </v-card-text>

        <v-card-actions class="text-center">
          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="error"
                  outlined
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="downloadInterpretation()"
                  :disabled="sending"
                >
                  Exportar PDF <v-icon right>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <span>Descargar PDF reporte de interpretes</span>
            </v-tooltip>
          </v-col>
          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  outlined
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="downloadInterpretationXLS()"
                  :disabled="sending"
                >
                  Exportar Excel <v-icon right>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Descargar Excel reporte de interpretes</span>
            </v-tooltip>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import moment from "moment";
import Datatable from "@/components/Datatable.vue";
import Sidebar from "@/components/Sidebar";
import BtnAccion from "@/components/btnAccion.vue";
import { InterpretationHistoryRequest, ReportPDFRequest } from "@/core/request";
import { UtilFront } from "@/core";
import AutoLogout from "../../components/AutoLogout.vue";
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import BranchOfficesList from "../../components/BranchOfficesList.vue";

export default {
  name: "InterpretationPendingView",
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    AutoLogout,
    Loader,
    BranchOfficesList,
  },
  computed: {
    dateCompuded() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return "";
      }

      return `${moment(this.date.start).format("DD/MM/YYYY")} al ${moment(
        this.date.end
      ).format("DD/MM/YYYY")}`;
    },
    validData() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return false;
      }
      this.listAll();
      return true;
    },
  },
  data: () => ({
    disabledHeader: false,
    date: "",
    sending: false,
    dateModel: { startDate: "", endDate: "" },
    rangeDate: "",
    rangeDateText: "",
    search: "",
    list: [],
    listFull: [],
    model: { modality: { acronym: "TD", title: "Todas" } },
    encabezado: {
      icono: "mdi-book-open",
      texto: "Intérpretes",
    },
    service: InterpretationHistoryRequest,
    headers: [
      { text: "Id Interpretación", value: "idInterpretation" },
      { text: "Id Estudio", value: "idStudy" },
      // { text: "Id Paciente", value: "idPatient" },
      { text: "Nombre del paciente", value: "fullNamePatient" },
      { text: "Modalidad", value: "nameModality" },
      { text: "Estudio", value: "nameStudy" },
      {
        text: "Fecha de interpretación",
        value: "registrationDateInterpretation",
      },
      { text: "Nombre del intérprete", value: "fullNameInterpreter" },
    ],
    btnDownload: {
      icon: "mdi-file-pdf-box",
      text: "Descargar PDF",
      tooltip: "Descargar reporte de intérpretes",
      color: "error",
    },
    btnDownloadXLSX: {
      icon: "mdi-file-excel",
      text: "Descargar excel",
      tooltip: "Descargar reporte de intérpretes",
      color: "success",
    },
    options: { page: 1, itemsPerPage: 10 },
    totalCount: 0,
    delayed: null,
    idBranchOfficeSelected: null,
    cols: "col-md-3 col-xl-3 col-sm-12",
    // :server-items-length="list.length"
    // :options.sync="options"
    // { "page": 2, "itemsPerPage": 10, "sortBy": [], "sortDesc": [], "groupBy": [], "groupDesc": [], "mustSort": false, "multiSort": false }
  }),
  created() {
    this.validBrowserTab();
    this.listAll();
  },
  watch: {
    /**
     * Método utilizado para el filtrado por página.
     */
    // options: function (newVal, oldVal) {
    //   if (
    //     newVal.page != oldVal.page ||
    //     newVal.itemsPerPage != oldVal.itemsPerPage
    //   ) {
    //     this.listAll();
    //   }
    // },
    // search: function (newVal, oldVal) {
    //   if (newVal == "") {
    //     this.listAll();
    //   } else {
    //     if (this.delayed) {
    //       clearTimeout(this.delayed);
    //       this.delayed = null;
    //     } else {
    //       this.search = newVal;
    //       this.delayed = setTimeout(this.listAll(), 500);
    //     }
    //   }
    // },
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError(e) {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    listAll() {
      try {
        this.sending = true;
        this.list = [];
        this.totalCount = 0;

        let data = {
          speciality: 2,
          filter: {
            page: this.options.page || 1,
            itemsPerPage: this.options.itemsPerPage || 10,
            search: this.search || "",
            idBranchOffice: this.idBranchOfficeSelected != null ? this.idBranchOfficeSelected : this.$utilFront.getIdBranchOffice(),
          },
        };

        if (this.$utilFront.nonEmpty(this.date)) {           
          data.filter.start = this.$utilFront.startOfDay(this.date.start);           
          data.filter.end = this.$utilFront.endOfDay(this.date.end);         
        }


        // if (data.filter.start != null && data.filter.end != null) {
        //   data.filter.start = moment(data.filter.start).startOf("day");
        //   data.filter.end = moment(data.filter.end).endOf("day");
        // }

        this.service
          .listAllInterpretedBySpeciality(data)
          .then((res) => {
            let { data, code, status, totalCount } = res.data;
            this.totalCount = totalCount;
            this.list = data.map((it) => {
              it.registrationDateInterpretation = this.$utilFront.formatDateTime(
                it.registrationDateInterpretation
              );
              return it;
            });
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    clearCalendar() {
      this.date = "";
      this.listAll();
    },

    downloadInterpretation() {
      this.sending = true;
      let data = {
        speciality: 2,
        filter: {
          page: this.options.page || 1,
          itemsPerPage: -1,
          search: this.search || "",
          start: null,
          end: null,
          idBranchOffice:this.idBranchOfficeSelected != null ? this.idBranchOfficeSelected : this.$utilFront.getIdBranchOffice(),
        },
      };


      if (this.$utilFront.nonEmpty(this.date)) {           
        data.filter.start = this.$utilFront.startOfDay(this.date.start);           
        data.filter.end = this.$utilFront.endOfDay(this.date.end);         
      }

      ReportPDFRequest.downloadInterpreters(data)
        .then((res) => {
          if (res.status == 200 && res.data.type != "application/json") {
            this.$utilFront.openPDF(res.data);
          } else {
            this.$utilFront.displayErrorPdf(res.data);
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    downloadInterpretationXLS() {
      this.sending = true;
      let data = {
        speciality: 2,
        filter: {
          page: this.options.page || 1,
          itemsPerPage: -1,
          search: this.search || "",
          start: null,
          end: null,
          idBranchOffice:
            this.idBranchOfficeSelected != null
              ? this.idBranchOfficeSelected
              : this.$utilFront.getIdBranchOffice(),
        },
      };

      
      if (this.$utilFront.nonEmpty(this.date)) {           
        data.filter.start = this.$utilFront.startOfDay(this.date.start);           
        data.filter.end = this.$utilFront.endOfDay(this.date.end);         
      }

      ReportPDFRequest.downloadInterpretationXLS(data)
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.ms-excel",
            })
          );

          /* Simulo el click */
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Reporte de intérpretes.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.sending = false;
        });
    },

    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAll();
    },
    // filterListDate() {
    //   try {
    //     if (this.date != null && this.date != undefined && this.date != "") {
    //       let dateStart = moment(new Date(this.date.start))
    //         .startOf("day")
    //         .toDate();
    //       let dateEnd = moment(new Date(this.date.end)).endOf("day").toDate();
    //       this.list = this.listFull.filter((obj) => {
    //         return (
    //           obj.dateInterpretation >= dateStart &&
    //           obj.dateInterpretation <= dateEnd
    //         );
    //       });
    //     } else {
    //       this.list = this.listFull.map((obj) => {
    //         return obj;
    //       });
    //     }
    //   } catch (error) {
    //     this.list = this.listFull.map((obj) => {
    //       return obj;
    //     });
    //     this.catchError(error);
    //   }
    // },
  },
};
</script>
